import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useGetBannerQuery } from '../../../api/queries/getBanner';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import BannerDetailsInnerPage from './BannerDetailsInnerPage';

const BannerDetailsPage = () => {
    const { bannerId } = useParams<{ bannerId: string }>();

    const { data, loading } = useGetBannerQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            id: bannerId,
        },
    });

    const banner = useMemo(() => data?.banner || null, [data?.banner]);

    if (!banner && loading) {
        return <LoadingElement />;
    }

    if (!banner) {
        return <NotFoundResult />;
    }

    return <BannerDetailsInnerPage banner={banner} />;
};

export default BannerDetailsPage;
